import { biLoggerFactory } from 'wix-private'
// import wixLocation from 'wix-location'
import wixWindow from 'wix-window'

import { biEvents } from 'public/biConsts'

const SRC = 134
const END_POINT = 'education'

// const defaultParams = {
//     page_url: wixLocation.url,
//     session_id: self.fedops.sessionId
// }

export const sendBi = (eventName, params = {}) => {
    if (wixWindow.rendering.env === 'backend') return

    const platformBiLogger = biLoggerFactory(END_POINT, SRC, {})

    const evid = biEvents[eventName]
    const mergedParams = Object.assign({}, params, { evid })

    // console.log('Frontend BI Event', evid, params)

    return platformBiLogger.log(mergedParams)
}

// import { biLoggerFactory } from 'wix-private'
// // import wixLocation from 'wix-location'
// import wixWindow from 'wix-window'

// const SRC = 134
// const END_POINT = 'education'

// // const defaultParams = {
// //     page_url: wixLocation.url,
// //     session_id: self.fedops.sessionId
// // }

// export const sendBi = (evid, params = {}) => {
//     if (wixWindow.rendering.env === 'backend') return

//     const platformBiLogger = biLoggerFactory(END_POINT, SRC, {})

//     const mergedParams = Object.assign({}, params, { evid })

//     console.log('BI Event', evid, params)

//     return platformBiLogger.log(mergedParams)
// }
